import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import runopsLogo from '../assets/runops-logo.png';

const LoginPage = ({ onLogin, onSignup }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSignup, setIsSignup] = useState(false);

  useEffect(() => {
    // Script is loaded globally from public/index.html. Only wait for appInsights to be available and then track.
    const checkAndTrack = () => {
      if (window.appInsights) {
        window.appInsights.trackPageView({ name: window.location.pathname });
      } else {
        setTimeout(checkAndTrack, 100);
      }
    };
    checkAndTrack();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    // Clear any previous errors
    setError('');

    if (isSignup) {
      // Signup logic
      if (password !== confirmPassword) {
        setError('Passwords do not match.');
        return;
      }
      const signupResult = await onSignup(username, password);
      if (signupResult.success) {
        setSuccess(signupResult.message);
        setError('');
        // Switch to login mode after successful signup
        setIsSignup(false);
        setUsername('');
        setPassword('');
        setConfirmPassword('');
        // Clear success message after 3 seconds
        setTimeout(() => setSuccess(''), 3000);
      } else {
        setError(signupResult.message);
        setSuccess('');
      }
    } else {
      // Login logic
      const loginSuccess = await onLogin(username, password);
      if (loginSuccess) {
        navigate('/'); // Navigate to homepage on success
      } else {
        // Show an error message on failure
        setError('Invalid username or password. Please try again.');
      }
    }
  };

  return (
    <div className="login-container">
      {/* Left Promotional Side */}
      <div className="login-promo">
        <div className="login-promo-logo">
          <img src={runopsLogo} alt="RunOps Logo" />
          <h1>RunOps AI Automation</h1>
        </div>
        <div className="login-promo-text">
          <h2>Experience the AI Framework for RunOps Automation</h2>
          <p>Streamlining AI infusion across IT Operations for enhanced resilience and efficiency.</p>
        </div>
        <p className="login-promo-footer">Copyright © 2025 Neurealm Private Limited</p>
      </div>

      {/* Right Login Form Side */}
      <div className="login-form-container">
        <div className="login-form-card">
          <div className="login-form-header">
            <div className="avatar-placeholder"><i className="fas fa-user"></i></div>
            <h3>{isSignup ? 'Sign Up for the Platform' : 'Login to the Platform'}</h3>
          </div>
          <form onSubmit={handleSubmit}>
            {/* Conditionally display the error message */}
            {error && <p className="login-error">{error}</p>}
            {/* Conditionally display the success message */}
            {success && <p className="login-success">{success}</p>}

            <div className="input-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="demouser@neurealm.com"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="input-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {isSignup && (
              <div className="input-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  id="confirmPassword"
                  type="password"
                  placeholder="••••••••"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            )}
            {/* <div className="login-options">
              <label><input type="checkbox" /> Keep me logged in</label>
              <a href="#forgot">Forgot password?</a>
            </div> */}
            <button
              type="submit"
              className="login-button"
            >
              {isSignup ? 'Sign Up' : 'Login'}
            </button>
          </form>
          {/* <div className="signup-toggle">
            <p>
              {isSignup ? 'Already have an account?' : "Don't have an account?"}{' '}
              <button
                type="button"
                className="link-button"
                onClick={() => {
                  setIsSignup(!isSignup);
                  setError('');
                  setSuccess('');
                  setUsername('');
                  setPassword('');
                  setConfirmPassword('');
                }}
              >
                {isSignup ? 'Login' : 'Sign Up'}
              </button>
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;